// Copyright © 2017-2020  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 sm4 offset-sm4>
        <v-card>
          <v-card-title>
            <span class="headline">Login</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
            label="Email"
            id="email"
            required
            v-model="credentials.username"
            v-on:keyup.enter="login()"
            :rules="[ruleEmail]"
            ></v-text-field>
            <v-text-field
            label="Password"
            id="password"
            type="password"
            required
            v-model="credentials.password"
            v-on:keyup.enter="login()"
            ></v-text-field>
            <router-link :to="{name: 'passwordResetRequest'}">Forgot My Password</router-link>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#2b4c6e" flat @click.native="login">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

  <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'
import axios from 'axios'
import Rules from 'vue-common/components/rules'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      credentials: {
        username: '',
        password: ''
      },
      errorText: '',
      ruleEmail: Rules.email
    }
  },

  methods: {
    login: function () {
      var credentials = {
        username: this.credentials.username,
        password: this.credentials.password
      }
      axios.post('/auth/loginredirect', credentials, {}).then(response => {
        console.log(response.data)
        window.location.href = response.data.url
      }).catch(e => {
        if (e.response.status === 401) {
          this.errorText = 'Invalid username or password'
        } else {
          console.log(e)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue